<template>
  <div class="form_add_page" v-loading="isLoading">
    <div class="top-container flex_between">
      <div class="flex_center" style="cursor: pointer" @click="back">
        <i class="el-icon-arrow-left" />
        <div class="split"></div>
        编辑二赔金额
      </div>

      <div class="button_list flex-right">
        <zip-btn
          :name="claimantInfo.claimStatementNum"
          v-show="claimantInfo.fileList && claimantInfo.fileList.length > 0"
          :fileList="claimantInfo.fileList"
        />
        <el-button size="mini" type="primary" @click="handleSave">保存</el-button>
      </div>
    </div>
    <detail
      v-if="formLoading"
      ref="detailRef"
      :claimantInfo.sync="claimantInfo"
    />
    <el-dialog
      :visible.sync="showComplete"
      width="420px"
      :close-on-click-modal="false"
      :show-close="false"
      :close-on-press-escape="false"
      center
    >
      <div style="text-align: center; width: 100%">
        <i
          class="el-icon-success"
          style="color: #67C23A; margin-right: 13px"
        />{{ completeTip }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="back">返回列表</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {confirmAmount, confirmAmountEdit, getClimantDetail} from "@/api/seek";
import Detail from "./components/detail.vue";
import zipBtn from "@/components/downloadZip";

export default {
  components: { Detail, zipBtn },
  data() {
    return {
      showComplete: false,
      completeTip: "",
      isLoading: false,
      claimantInfo: {},
      formLoading: false
    };
  },
  async mounted() {
    if (this.$route.query?.claimantId) {
      this.isLoading = true;
      const res = await getClimantDetail(this.$route.query?.claimantId);
      if (res.status == 0) {
        this.claimantInfo = res.data || {};
        if (
          this.claimantInfo.responsibilityPartList &&
          this.claimantInfo.responsibilityPartList.length > 0
        ) {
          this.claimantInfo.responsibilityPartList.map((item, index) => {
            this.claimantInfo.responsibilityPartList[index].secondDamages =
              item.secondDamages ?? undefined;
          });
        }
      } else {
        this.$DonMessage.error(res.message);
      }
      this.isLoading = false;
    }
    this.$nextTick(() => {
      this.formLoading = true;
    });
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    async handleSave() {
      this.$refs.detailRef.$refs.form.validate(async valid => {
        if (!valid) return;
        const submitData = JSON.parse(JSON.stringify(this.claimantInfo));
        this.isLoading = true;
        try {
          var res = await confirmAmountEdit({ data: submitData });
          if (res.status == 0) {
            this.isLoading = false;
            this.completeTip = `索赔订单 ${this.claimantInfo.claimStatementNum} 已保存`;
            this.showComplete = true;
          } else {
            this.isLoading = false;
            this.$DonMessage.error(res.message);
          }
        } catch (error) {
          this.isLoading = false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.form_add_page {
  padding-bottom: 20px;
  .top-container {
    position: sticky;
    top: 0;
    z-index: 999;
    background-color: #fff;
    padding: 15px 32px 15px 14px;
    border-bottom: 5px solid #efefef;
    .split {
      margin: 0 10px 0 7px;
      border: 1px solid #dde0e8;
      height: 18px;
    }
  }
}
</style>
